import React from 'react'
import SETTING_RADIUS from './SETTING_RADIUS';
import { useSelector } from 'react-redux';
import SETTING_ISOCHRONE from './SETTING_ISOCHRONE';
import { Draggable } from '../reuseable';
import SETTING_ELEVATION from './SETTING_ELEVATION';
import SETTING_ROUTING from './SETTING_ROUTING';

function TOOLBOX_SETTING() {
  const { is_mobile } = useSelector((state) => (state.properties));
  const toolbox = useSelector((state) => (state.toolbox)) || {};
  const layer = useSelector((state) => (state.layer)) || {};
  const {
    uuid_name,
    is_need_setting,
    mode_toolbox,
  } = toolbox;
  const selected_row_toolbox_ids = toolbox[uuid_name];
  const { statistic_mode } = layer;

  let content = null;

  if (mode_toolbox === "features_radius") {
    content = <SETTING_RADIUS />
  } else if (mode_toolbox === "features_isochrone") {
    content = <SETTING_ISOCHRONE />
  } else if (mode_toolbox === "features_elevation") {
    content = <SETTING_ELEVATION />
  } else if (mode_toolbox === "features_routing") {
    content = <SETTING_ROUTING />
  }


  return (
    <>
      {
        statistic_mode === "toolbox" &&
        is_need_setting &&
        (
          (
            selected_row_toolbox_ids?.length > 0 && 
            mode_toolbox !== "features_routing"
          ) ||
          mode_toolbox === "features_routing"
        ) &&
        <Draggable
          style={{
            background: "white",
            zIndex: 0,
            width: "230px",
            // width: "366px",

            backgroundColor: "white",
            borderRadius: "20px",
            color: "black",
            gap: "15px",
          }}
          initialPosition={{
            // x: is_mobile ? 20 : window.innerWidth - 750,
            x: is_mobile ? 20 : window.innerWidth - 600,
            y: is_mobile ? 320 : 334,
          }}
        >
          {content}
        </Draggable>
      }
    </>
  )
}

export default TOOLBOX_SETTING